import { Component, OnInit } from '@angular/core';
import { ReturnObject } from '../../models/returnObject';
import { InfoMessageService } from '../../services/infomessage/infomessage.service';
import { InfoMessageItem } from '../../models/infomessage';
import { StatusMessagesService } from '../../services/statusmessage.service';
import { InternalMsgService } from '../../services/internal.msg.service';
import { MessageTypeItem } from '../../models/messagetypeitem';

@Component({
    selector: 'sysadmin-set-infomsg',
    templateUrl: './sysadmin-set-infomsg.component.html',
    styleUrls: ['./sysadmin-set-infomsg.component.css'],
    providers: [],
})
export class SysadminSetInfomsgComponent implements OnInit {
    fromDate: string = '';
    toDate: string = '';
    infoMsg = '';
    headerText = '';
    infoMessages: InfoMessageItem[] = [];
    urgency: string = '1';
    spinnerMessage: string = '';

    messageTypes: MessageTypeItem[] = [ {"importance": 1, "typeText": "Maintenance"},
        {"importance": 2, "typeText": "Educational"},
        {"importance": 3, "typeText": "Other Info"}];

    constructor(private infoMessageService: InfoMessageService,
        private msgService: InternalMsgService,
        private statusMessagesService: StatusMessagesService) {
        this.getActiveMessages(); 
    }

    ngOnInit() {
        const today = new Date();
        this.fromDate = today.toISOString().toString().split('T')[0];
        this.toDate = today.toISOString().split('T')[0];
    }

    submitData() : void {
        this.msgService.ontoggleSpinnerSet(true);

        const fromDate: string = this.fromDate;
        const toDate: string = this.toDate;
        const fromDateConvToDate: Date = new Date(fromDate);
        const toDateConvToDate: Date = new Date (toDate);

        this.infoMessageService
            .setInfoMessage(fromDateConvToDate, toDateConvToDate, this.urgency, this.infoMsg, this.headerText)
            .subscribe( { 
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.getActiveMessages();
                    this.statusMessagesService.showToasterSuccess('Saved', data.value);
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

    deleteMessage(id: number) : void {
        this.msgService.ontoggleSpinnerSet(true);
        this.infoMessageService.deleteMessage(id)
            .subscribe( { 
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.getActiveMessages();
                    this.statusMessagesService.showToasterSuccess('Deleted', data.value);
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

    getActiveMessages() : void {
        this.msgService.ontoggleSpinnerSet(true);
        this.infoMessageService.getActiveAndScheduledMessages()
            .subscribe( { 
                next: (data: ReturnObject<InfoMessageItem[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.infoMessages = data.value;
                },
                error: (err) => {         
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {         
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }


    isSaveDisabled(): boolean {
        if (this.fromDate == '' || this.toDate == '') return true;

        const dtFrom: Date = new Date(this.fromDate);
        const dtTo: Date = new Date(this.toDate);
        return this.infoMsg.trim() === ''
        || this.headerText.trim() === ''
        || (dtTo < dtFrom);
    }

    isActive(fromDate: Date): boolean {
        const inputDate = new Date(fromDate);
        const thisDate = new Date();
        return (inputDate < thisDate);
    }

    getMessageTypeText(importance: number): string {
        const msgType: MessageTypeItem | undefined = this.messageTypes.find( x => x.importance == importance); 
        return msgType
            ? msgType.typeText
            : 'Other info';          
    }
}

